module.exports = __webpack_public_path__ + "img/bar_chart_dashboard.129906c2.svg";